export default __webpack_public_path__ + "static/media/crypto.com-capital.5ffd6cd4.png";